'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var setClientDefaultReqHeaders = exports.setClientDefaultReqHeaders = function setClientDefaultReqHeaders() {
  var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    args: { headers: headers },
    type: 'MINDSELF_SET_CLIENT_DEFAULT_REQ_HEADERS',
    headers: headers
  };
};

var setAuthorizationInfo = exports.setAuthorizationInfo = function setAuthorizationInfo(userId, Authorization) {
  return {
    args: { userId: userId, Authorization: Authorization },
    type: 'MINDSELF_SET_AUTHORIZATION_INFO',
    payload: { userId: userId, Authorization: Authorization }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/actions/httpClient.js
// module id = 508
// module chunks = 1